import { Variants } from "@enkor/framer-motion";

import * as S from "./ConfirmModal.style";

const sheetVariants: Variants = {
  hidden: { x: "-50%", y: "-50%", scale: 1.2, opacity: 0 },
  visible: {
    x: "-50%",
    y: "-50%",
    scale: 1,
    opacity: 1,
    transition: { duration: 0.4, ease: [0.05, 0.7, 0.1, 1.0] },
  },
  exit: {
    x: "-50%",
    y: "-50%",
    scale: 1.2,
    opacity: 0,
    transition: { duration: 0.2, ease: [0.3, 0.0, 0.8, 0.15] },
  },
};

interface ConfirmModalProps {
  modalTitle: string;
  modalDescription: string;
  cancelButton: {
    buttonText?: string;
    onClickCancel: () => void;
  };
  confirmButton: {
    buttonText?: string;
    id?: string;
    onClickConfirm: () => void;
  };
}

const ConfirmModal = ({
  modalTitle,
  modalDescription,
  cancelButton,
  confirmButton,
}: ConfirmModalProps) => {
  return (
    <S.Container
      variants={sheetVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <S.ModalHeader name="h6">{modalTitle}</S.ModalHeader>
      <S.ModalContent name="m">{modalDescription}</S.ModalContent>
      <S.ButtonWrapper>
        <S.CancelButton type="button" onClick={cancelButton.onClickCancel}>
          {cancelButton?.buttonText || "Cancel"}
        </S.CancelButton>
        <S.ConfirmButton
          type="button"
          id={confirmButton.id}
          onClick={confirmButton.onClickConfirm}
        >
          {confirmButton?.buttonText || "Confirm"}
        </S.ConfirmButton>
      </S.ButtonWrapper>
    </S.Container>
  );
};

export default ConfirmModal;
